import "firebase/auth"
import { Fragment, useEffect } from "react"
import { useUser } from "reactfire"
import {
  useDisclosure,
  Box,
  Center,
  Container,
  Grid,
  Spinner,
} from "@chakra-ui/react"

import Header from "./PageHeader"
import Sidebar from "./PageSidebar"
import SignInForm from "../Auth/SignInForm"

const Page = ({ title, back, isLoading, toolbar, children }) => {
  const { status, data: user, hasEmitted } = useUser()
  const { isOpen, onOpen, onClose } = useDisclosure()

  useEffect(() => (document.title = `Agrifood | ${title}`), [title])

  if (status === "loading" || hasEmitted === false) {
    return (
      <Center p={16}>
        <Spinner />
      </Center>
    )
  }

  return user ? (
    <Fragment>
      <Grid templateColumns={{ base: "1fr", lg: "14rem 1fr" }} gap={0}>
        <Sidebar isOpen={isOpen} onClose={onClose} />
        <Box h="100vh" overflowY="auto">
          <Header
            title={title}
            back={back}
            isLoading={isLoading}
            toolbar={toolbar}
            onOpen={onOpen}
          />
          <Box as="main" p={4} bg="white">
            <Container maxW="container.2xl" overflowX="auto">
              {isLoading ? (
                <Center p={16}>
                  <Spinner />
                </Center>
              ) : (
                children
              )}
            </Container>
          </Box>
        </Box>
      </Grid>
    </Fragment>
  ) : (
    <SignInForm />
  )
}

export default Page
